module.exports = __webpack_public_path__ + "static/media/cq_carica b.dcce279f.svg";